<template>
    <b-container align-v="center" class="container">
        <b-card no-body>
            <b-card-text>
        <div v-if="subscription == 'paid'" class="row">
            <div class="col-md-6">
                <h2>Subscription Details</h2>
            </div>
            <div class="col-md-6 text-right">
                <span>Renewal Date: </span> <span class="font-weight-bold"> {{ renewalDate }} </span>
            </div>

            <div class="col-md-12 col-sm-12">
                <div class="table-section table-min-width">
                    <b-table
                        :fields="subscriptionFields"
                        :items="data"
                        no-local-sorting
                    >
                        <template slot="tier" slot-scope="data">
                            <span>{{ data.item.additionalProfiles || data.item.tier }}</span>
                        </template>

                        <template slot="packageType" slot-scope="data">
                            <span>{{ convertToTitleCase( data.item.package && data.item.package.type ? data.item.package.type : dataSegment.accountType == 'standard' ? 'pro' : dataSegment.accountType ) }}</span>
                        </template>
                        <!-- <template slot="dealType" slot-scope="data">
                            <span>{{
                                data.item.dealType ? data.item.dealType : 'N/A'
                            }}</span>
                        </template> -->
                        <template slot="subscriptionDate" slot-scope="data">
                            <span>{{
                                data.item.subscriptionDate
                                    ? $moment(
                                          data.item.subscriptionDate
                                      ).format(' DD-MM-YYYY')
                                    : 'N/A'
                            }}</span>
                        </template>
                        <template slot="expiredOn" slot-scope="data">
                            <span>{{
                                data.item.expiryDate
                                    ? $moment(data.item.expiryDate).format(
                                          ' DD-MM-YYYY'
                                      )
                                    : 'N/A'
                            }}</span>
                        </template>
                        <template slot="invoiceId" slot-scope="data">
                            <div v-if="data.item.invoiceId" class="action-review">
                                <base-action
                                    icon="icon-eye-view"
                                    label="View Invoice"
                                    @click="
                                        $router.push({
                                            name: 'invoice-details',
                                            params: {
                                                id: data.item.invoiceId,
                                            },
                                        })
                                    "
                                ></base-action>
                            </div> 
                        </template>
                    </b-table>
                    <base-table-spinner
                        v-if="!data.length && showPageLoader"
                    ></base-table-spinner>
                    <!-- When record not found -->
                    <base-no-record-found
                        v-if="!data.length && !showPageLoader"
                    ></base-no-record-found>
                </div>
                <!-- <hr />
                To change your subscription or billing details, go to the
                billing portal <br />
                <b-button
                    type="button"
                    variant="primary"
                    class="mt-3"
                    @click="onBilling()"
                    >Go to Billing Portal</b-button
                > -->
            </div>

            <div class="col-12 mt-3" v-if="currentPackageType">
                <ProfileCalculator :taxPercentage="taxPercentage" :tier="parseInt(tier)" :user="user" :packages="packagesCategorized[currentPackageType]" />
            </div>
        </div>

        <div v-if="subscription != 'paid'">
            <h2 style="text-align: center; padding: 20px 0px">
                Select a plan that works for you
                <br />
                <small style="font-size: 50%"
                    >All prices are exclusive of VAT</small
                >
            </h2>
            <b-tabs pills card active-tab-class="font-weight-bold" align="center">
                <b-tab
                        v-for="(category, index) in Object.keys(packagesCategorized)"
                        :title="convertToTitleCase(category)"
                        :key="index"
                        title-link-class="font-weight-bold"
                    >
                    <div class="row">
                                <template
                                    v-for="(pkg, index) in packagesCategorized[category].filter(el =>!el.hideFromPricingPage)"
                                >
                                    <div
                                        v-if="pkg.isCustom"
                                        class="col-md-4 mt-2"
                                    >
                                        <!--PRICE CONTENT START-->
                                        <div class="generic_content clearfix">
                                            <!--HEAD PRICE DETAIL START-->
                                            <div
                                                class="generic_head_price clearfix"
                                            >
                                                <!--HEAD CONTENT START-->
                                                <div
                                                    class="generic_head_content clearfix"
                                                >
                                                    <!--HEAD START-->
                                                    <div class="head_bg"></div>
                                                    <div class="head">
                                                        <span>{{
                                                            pkg.title
                                                        }}</span>
                                                    </div>
                                                    <!--//HEAD END-->
                                                </div>
                                                <!--//HEAD CONTENT END-->
                                                <!--PRICE START-->
                                                <div
                                                    class="generic_price_tag clearfix"
                                                >
                                                    <span class="price">
                                                        <span class="sign">{{
                                                            pkg.currency
                                                        }}</span>
                                                        <span class="month">{{
                                                            pkg.firstTimePrice || pkg.price
                                                        }}</span>
                                                        <!--<span class="month"-->
                                                            <!--&gt;/{{-->
                                                                <!--pkg.period-->
                                                            <!--}}</span-->
                                                        <!--&gt;-->
                                                    </span>
                                                </div>
                                                <!--//PRICE END-->
                                            </div>
                                            <!--//HEAD PRICE DETAIL END-->
                                            <!--FEATURE LIST START-->
                                            <div class="generic_feature_list">
                                                <ul>
                                                    <li
                                                        v-for="(
                                                            line, lineIndex
                                                        ) in pkg.description"
                                                        :key="lineIndex"
                                                    >
                                                        {{ line }}
                                                    </li>
                                                </ul>
                                            </div>
                                            <!--//FEATURE LIST END-->
                                            <b-form-input
                                                v-model="pkg.quantity"
                                                placeholder="Enter Custom Quantity"
                                                class="custom-input-quantity"
                                            ></b-form-input>
                                            <div
                                                class="mt-2"
                                                style="color: #a0a1a2"
                                            >
                                                You will purchase
                                                {{ pkg.quantity }} Onboardings
                                            </div>
                                            <!--BUTTON START-->
                                            <b-button
                                                v-b-modal.modal-1
                                                variant="secondary"
                                                :disabled="!pkg.quantity"
                                                @click.prevent="
                                                    onSubmit(
                                                        pkg,
                                                        pkg.quantity,
                                                        true,
                                                        index
                                                    )
                                                "
                                                >Subscribe</b-button
                                            >
                                            <!--//BUTTON END-->
                                        </div>
                                        <!--//PRICE CONTENT END-->
                                    </div>
                                    <div v-else class="col-md-4 mt-2">
                                        <!--PRICE CONTENT START-->
                                        <div class="generic_content clearfix shadow">
                                            <!--HEAD PRICE DETAIL START-->
                                            <div
                                                class="generic_head_price clearfix"
                                            >
                                                <!--HEAD CONTENT START-->
                                                <div
                                                    class="generic_head_content clearfix"
                                                >
                                                    <!--HEAD START-->
                                                    <!-- <div class="head_bg"></div> -->
                                                    <div class="head">
                                                        <span>{{
                                                            pkg.title
                                                        }}</span>
                                                    </div>
                                                    <!--//HEAD END-->
                                                </div>
                                                <!--//HEAD CONTENT END-->

                                                <!--PRICE START-->
                                                <div
                                                    class="generic_price_tag clearfix"
                                                >
                                                    <span class="price">
                                                        <!-- <span class="sign">{{
                                                            pkg.currency
                                                        }}</span> -->
                                                        <span
                                                            class="currency"
                                                            >
                                                            {{ pkg.currency=="GBP" ? "£": pkg.currency }}
                                                            {{
                                                                pkg.firstTimePrice
                                                            }}</span
                                                        >
                                                        <!-- <span class="cent"> &nbsp; for 1st year</span> -->
                                                        <!--<span class="month"-->
                                                            <!--&gt;/{{-->
                                                                <!--pkg.period-->
                                                            <!--}}</span-->
                                                        <!--&gt;-->
                                                    </span>
                                                </div>
                                                <!--//PRICE END-->

                                                <div class="mt-4">
                                                    <!-- <p class="text-muted">Annual Renewal Price {{ pkg.currency }} {{ pkg.renewalPrice }}</p> -->
                                                    <!--BUTTON START-->
                                                    <b-button
                                                        v-b-modal.modal-2
                                                        variant="secondary"
                                                        @click.prevent="onSubmit(pkg)"
                                                        >Subscribe</b-button
                                                    >
                                                    <!--//BUTTON END-->
                                                </div>

                                            </div>
                                            <!--//HEAD PRICE DETAIL END-->
                                            
                                            <!--FEATURE LIST START-->
                                            <!-- <div class="generic_feature_list"> -->
                                            <div class="generic_feature_list tick-list text-left">
                                                <ul>
                                                    <li
                                                        v-for="(
                                                            line, lineIndex
                                                        ) in pkg.type == 'premium' ? premiumPackageDescriptions : packageDescriptions"
                                                        :key="lineIndex"
                                                    >
                                                        {{ line }}
                                                    </li>
                                                    <!-- <li>Upto <span>100</span> Onboardings</li>
                                            <li>Namescreening</li>
                                            <li>Document Verification</li>
                                            <li>KYC Risk Rating</li> -->
                                                    <!-- <li><span>24/7</span> Support</li> -->
                                                </ul>
                                            </div>
                                            <!--//FEATURE LIST END-->
                                            <div class="pricing-info">
                                                <ul>
                                                    <li>Additional Profiles can be purchased when you need</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <!--//PRICE CONTENT END-->
                                        
                                    </div>
                                </template>
                            </div>

                </b-tab>
            </b-tabs>
                        

            <!-- card 4 -->
                </div>
            </b-card-text>
        </b-card>
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import resource from '@/api/resource'
import ProfileCalculator from './ProfileCalculator.vue'
import _ from 'lodash'

const apiUrl = process.env.VUE_APP_API_URL
const dataSegmentApi = new resource('users/data-segment')
//const pricesApi = new resource('users/prices')

export default {
    components: {
        ProfileCalculator,
    },
    data: function () {
        return {
            counter: null,
            subscription: null,
            dataSegment: null,
            packageDescriptions: [
                "Name screening",
                "Document Verification",
                "KYC Risk Rating",
                "KYB Risk Rating",
            ],
            premiumPackageDescriptions: [
                "Name screening",
                "Document Verification",
                "KYC Risk Rating",
                "KYB Risk Rating",
                "White Labelling",
                "Adverse Media Rescreening",
            ],
            subscriptionFields: [
                {
                    key: 'tier',
                    label: 'Onboardings',
                    sortable: true,
                },
                {
                    key: 'packageType',
                    label: 'Package Type',
                    sortable: true,
                },
                // {
                //     key: 'dealType',
                //     label: 'Subscription Type',
                //     sortable: true,
                // },
                {
                    key: 'subscriptionDate',
                    label: 'Subscribed On',
                    sortable: true,
                },
                // {
                //     key: 'expiredOn',
                //     label: 'Renewal Date',
                //     sortable: true,
                // },
                {
                    key: 'invoiceId',
                    label: 'Action',
                },
            ],
            isCategory: false,
            category: '',
            data: [],
            tier: null,
            quantity: '',
            quantityYearly: '',
            csrfToken: null,
            monthlyKey: process.env.VUE_APP_STRIPE_PRICE_ID,
            yearlyKey: process.env.VUE_APP_STRIPE_PRICE_ID_ANNUAL,
            yearlyProKey: process.env.VUE_APP_STRIPE_PRICE_ID_ANNUAL_PRO,
            yearlyLiteKey: process.env.VUE_APP_STRIPE_PRICE_ID_ANNUAL_LITE,
            packages: [],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['user', 'dataSegmentId', 'dataSegmentList']),
        currentPackageType(){
            if (this.dataSegment && this.dataSegment.packageDetails && this.dataSegment.packageDetails.length) {
                let pkg = this.dataSegment.packageDetails.find(el => el.status == 'active' && el.isPrimary == true)
                return pkg && pkg.package ? pkg.package.type : null 
            }
            return null
        },
        packagesCategorized(){
            const showProPackages = this.dataSegment ? !this.dataSegment.whiteLabelling : false
            if(this.packages && this.packages.length) {
                let allPackages = [...this.packages,]
                if(!showProPackages) {
                    allPackages = allPackages.filter(el => el.type != 'pro')
                }
               return allPackages.reduce((prev, curr) => {
                if(Array.isArray(prev[curr.type])) {
                    prev[curr.type].push(curr)
                } else {
                    prev[curr.type] = [curr,]
                }
                return prev
               }, {})  
            }
            return {}
        },
        taxPercentage(){
            if(this.dataSegment) {
                return this.dataSegment.taxPercentage; 
            }
        },
        yearlyTitle() {
            if (!this.packages || this.packages.length < 1) {
                return 'Yearly'
            }
            let pkg = this.packages.find(
                (el) => el.category.toLowerCase() == 'pro'
            )
            if (pkg) {
                this.isCategory = true
                this.category = 'Pro'
                return 'Pro'
            } else {
                return 'Yearly'
            }
        },
        monthlyTitle() {
            if (!this.packages || this.packages.length < 1) {
                return 'Monthly'
            }
            let pkg = this.packages.find(
                (el) => el.category.toLowerCase() == 'basic'
            )
            if (pkg) {
                this.isCategory = true
                this.category = 'Basic'
                return 'Basic'
            } else {
                return 'Monthly'
            }
        },
        renewalDate() {
            if(this.data && this.data.length) {
                let pkg = this.data.find(el => el.status == 'active' && el.isPrimary == true)
                if (!pkg && this.data.length) {
                    let primaryPkgs = this.data.filter(el => el.isPrimary == true) 
                    if(primaryPkgs.length) {
                        pkg = primaryPkgs[primaryPkgs.length - 1]
                    }
                    
                }
                return pkg ? this.$moment(pkg.expiryDate).format('MMMM DD, YYYY') : ''; 
            }
            return '';
        },

        monthlyPackages() {
            return this.packages.filter((el) =>
                el.category
                    ? el.category.toLowerCase() == 'basic' &&
                      el.status.toLowerCase() == 'active'
                    : el.period.toLowerCase() == 'monthly' &&
                      el.status.toLowerCase() == 'active'
            )
        },
        yearlyPackages() {
            return this.packages.filter((el) =>
                el.category
                    ? el.category.toLowerCase() == 'pro' &&
                      el.status.toLowerCase() == 'active'
                    : el.period.toLowerCase() == 'yearly' &&
                      el.status.toLowerCase() == 'active'
            )
        },
    }, // End of Component > mounted

    mounted() {
        // this.getCSRFToken()
        this.getAllPackages()
        this.getCounter()
        //this.getPricing()
    },
    methods: {
        convertToTitleCase(str){
            return _.startCase(str)
        },
        async getCSRFToken() {
            let response = await axios.get(apiUrl + 'users/getcsrftoken')
            axios.defaults.headers.common['X-CSRF-TOKEN'] =
                response.data.csrfToken
            this.csrfToken = response.data.csrfToken
            console.log(response.data.csrfToken)
        },
        async getAllPackages() {
            try {
                // let type = this.user.accountType
                //    ? this.user.accountType
                //    : 'standard'
                let { data } = await axios.get(
                    // apiUrl + 'users/packages/' + type
                    apiUrl + 'users/packages/'
                )
                if (data && data.data) {
                    this.packages = data.data.packages
                }
            } catch (e) {
                console.log('err: ', e)
            }
        },
        async onSubmit(pkg) {
            this.$router.push({
                name: 'stripe-subscription-checkout',
                params: {
                        packageId: pkg._id,
                    },
            })
        },
        // async onSubmit(pkg, quantity = 0, isCustom = false, index = 0) {
        //     try {
        //         let value = isCustom ? pkg.onboardings : 1;
        //         let key = pkg.stripePriceId;
        //         let flatFee = pkg.firstTimePrice - pkg.renewalPrice; 
        //         if (isCustom || this.user.accountType == 'lite') {
        //             if (isCustom) {
        //                 if (index == 1) {
        //                     if (
        //                         quantity == '' ||
        //                         parseInt(quantity) < 1001 ||
        //                         parseInt(quantity) > 5000
        //                     ) {
        //                         this.$store.commit(
        //                             'setError',
        //                             'You can only enter value from 1001 to 5000'
        //                         )
        //                         return
        //                     }
        //                 }
        //                 if (index == 2) {
        //                     if (quantity == '' || parseInt(quantity) < 5001) {
        //                         this.$store.commit(
        //                             'setError',
        //                             'You can only enter value more than 5000'
        //                         )
        //                         return
        //                     }
        //                 }
        //             }
        //             key = this.yearlyLiteKey
        //             value = isCustom ? quantity : value
        //         }

        //         this.$analytics.fbq.event(
        //             'subscribe ' + value + ' onBoardingPackageClick'
        //         )
        //         console.log('number of profiles => ', value, 'key => ', key)

        //         let data = await this.$store.dispatch('createCheckoutSession', {
        //             user: this.user,
        //             priceId: key,
        //             quantity: value,
        //             flatFee,
        //         })
        //         console.log('this is the data----', data)
        //         if (data && data.id && data.url) {
        //             window.open(data.url)
        //         }
        //     } catch (error) {
        //         console.log(error)
        //     }
        // },
        async onSubmitCustom(value, key = process.env.VUE_APP_STRIPE_PRICE_ID) {
            try {
                this.$analytics.fbq.event(
                    'subscribe ' + value + ' onBoardingPackageClick'
                )
                console.log('number of profiles => ', value, 'key => ', key)
                console.log('an', this.yearlyKey)
                if (value == '' || parseInt(value) < 1001) {
                    this.$store.commit(
                        'setError',
                        'You can only enter 1001 or more as a value'
                    )
                    return
                }
                // onLogout action in auth store
                let data = await this.$store.dispatch('createCheckoutSession', {
                    user: this.user,
                    priceId: key, //'price_1Io8ZzHoDw6DABRYF6exn9sG',
                    quantity: value,
                })
                console.log(data)
            } catch (error) {
                console.log(error)
            }
        },
        async getCounter() {
            let dataSegment = await dataSegmentApi.get(this.dataSegmentId)
            let details = false
            this.dataSegment = dataSegment ? dataSegment.data ? dataSegment.data.data : '' : ''; 
            if (dataSegment.data.data.packageDetails) {
                // this.data = dataSegment.data.data.packageDetails.filter(el=> el.status=='active')
                this.data = dataSegment.data.data.packageDetails
                this.data = this.data.map((item) => {
                    if (item.dealType && item.subscriptionDate) {
                        console.log('item', item)
                        details = true
                        return {
                            ...item,
                            tier: dataSegment.data.data.tier,
                        }
                    }
                })
            }
            this.tier = dataSegment.data.data.tier
            this.subscription =
                this.tier &&
                this.tier > 0 &&
                this.data &&
                this.data.length &&
                details
                    ? 'paid'
                    : 'unpaid'
            if (this.subscription == 'unpaid') {
                this.counter = 0
            } else {
                this.counter = dataSegment.data.data.counter
            }
        },
        async getPricing() {
            //            let data = await axios.get(apiUrl + pricesApi)
            console.log(this.csrfToken)
            // axios.defaults.headers.common['X-CSRF-TOKEN'] = this.csrfToken
            let { data } = await axios.post(apiUrl + 'users/prices')
            console.log(data)
        },
        async onBilling() {
            try {
                // onLogout action in auth store
                await this.$store.dispatch(
                    'stripeCustomerPortalRedirect',
                    this.user
                )
            } catch (error) {
                console.log(error)
            }
        },

        getExpiryDate(obj) {
            let expiryDate = 'N/A'
            if (obj && obj.subscriptionDate) {
                if (obj.dealType) {
                    if (obj.dealType == 'Monthly') {
                        expiryDate = this.$moment(obj.subscriptionDate)
                            .add(29, 'days') // Add 30 days to the date
                            .format('DD-MM-YYYY')
                    }
                    if (obj.dealType == 'Annual') {
                        expiryDate = this.$moment(obj.subscriptionDate)
                            .add(364, 'days') // Add 30 days to the date
                            .format('DD-MM-YYYY')
                    }
                }
            }
            return expiryDate
        },
    },
}
</script>
